import { api } from '@/lib/api-client.ts'
import { AxiosError } from 'axios'
import { getCurrentOrganization } from '@/lib/utils.ts'
import { useProjectRolesStore } from '@/routes/settings/projectRoles/lib/state/useProjectRolesStore.ts'
import { LoaderFunctionArgs } from 'react-router-dom'

export const getProjectRoles = async ({ params }: LoaderFunctionArgs) => {
  let getUrl = `/organizations/${params.organizationId}/project_roles`
  const { setProjectRoles } = useProjectRolesStore.getState()
  if (params.projectId) {
    getUrl = `/projects/${params.projectId}/project_roles`
  } else {
    const organizationId = getCurrentOrganization()?.organization?.id
    if (!organizationId) {
      return null
    }
    getUrl = `/organizations/${organizationId}/project_roles`
  }
  try {
    const response = await api.get(getUrl)
    const projectRoles = response.data
    if (projectRoles) {
      setProjectRoles(projectRoles)
    }
    return projectRoles
  } catch (error) {
    if (error instanceof AxiosError) {
      return null
    }
  }
  return null
}
